/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Consent_RejectInputs */

const en_consent_reject = /** @type {(inputs: Consent_RejectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reject analytics`)
};

/**
* | output |
* | --- |
* | "Reject analytics" |
*
* @param {Consent_RejectInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const consent_reject = /** @type {((inputs?: Consent_RejectInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Consent_RejectInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_consent_reject(inputs)
});